(function () {
  'use strict';

  // Eraya price-test theme bridge for the "Hyper" (FoxTheme) theme.
  // The PriceTestEngine does not watch the DOM, so we re-apply test prices
  // whenever the theme re-renders a price: on PDP variant change and when
  // AJAX cards (recommendations / predictive search / quick-add) are injected.
  // Markers used for the deploy diagnostic in the skill: priceMorph, variant-change.

  function getManager() {
    try {
      var E = window.Eraya;
      if (E && E.sdk && typeof E.sdk.getPriceTestManager === 'function') {
        return E.sdk.getPriceTestManager();
      }
    } catch (_) {}
    return null;
  }

  function reapply(productId, variantId) {
    var mgr = getManager();
    if (!mgr) return;
    try {
      if (productId && variantId && typeof mgr.updatePricesForProduct === 'function') {
        mgr.updatePricesForProduct(String(productId), String(variantId));
      } else if (typeof mgr.updatePricesOnCurrentPage === 'function') {
        mgr.updatePricesOnCurrentPage();
      }
    } catch (_) {}
  }

  function syncVariantAttr(productId, variantId) {
    if (!productId || !variantId) return;
    document
      .querySelectorAll('[data-product-id="' + productId + '"]')
      .forEach(function (el) {
        el.setAttribute('data-variant-id', String(variantId));
      });
  }

  // 0. STAMP ERAYA TEST PROPERTIES ON NATIVE /cart/add FORM SUBMITS
  //    The SDK's CartTrackingManager only patches fetch/XHR, so a NATIVE
  //    (full-page navigation) product-form submit — e.g. a search / quick-add
  //    form that was never AJAXified — bypasses it entirely: no `_eraya_*`
  //    line-item properties get stamped. That means the price test isn't CHARGED
  //    (shopper pays the original price — a display-only bait-and-switch) AND
  //    every OTHER active test (theme / URL-redirect / shipping / cross-store /
  //    checkout / content / page / offer …) loses its order attribution.
  //    We stamp both here as hidden inputs so the native POST body carries them:
  //      - PRICE props  → getSimpleCartProperties(productId, variantId)   [charges]
  //      - GLOBAL props → getCartTrackingManager().getGlobalTestProperties() [attribution]
  //
  //    Fail-closed money guard: PRICE props are only added when we resolve a
  //    SINGLE exact variant. On anything ambiguous (id[]/multiple/missing) we skip
  //    the price — the shopper pays the real price (a missed test), never an
  //    undercharge. getSimpleCartProperties is itself fail-closed too. GLOBAL
  //    attribution props aren't variant-priced, so they're safe to stamp regardless.
  function getCartTracker() {
    try {
      var E = window.Eraya;
      if (E && E.sdk && typeof E.sdk.getCartTrackingManager === 'function') {
        return E.sdk.getCartTrackingManager();
      }
    } catch (_) {}
    return null;
  }

  function singleVariantId(form) {
    var ids = form.querySelectorAll('[name="id"], [name="id[]"]');
    if (ids.length !== 1) return null; // 0 = no variant, >1 = bundle/multi-line
    if (ids[0].name === 'id[]') return null; // array field => treat as multi-line
    var v = (ids[0].value || '').trim();
    // normalize a GID (gid://shopify/ProductVariant/123 -> 123)
    var m = v.match(/(\d+)\s*$/);
    return m ? m[1] : null;
  }

  function stampFormWithTestProperties(form) {
    var mgr = getManager();
    var variantId = singleVariantId(form); // null on bundle/multi-line/missing

    // Resolve product id best-effort (needed for the price lookup + content tests).
    var productId = null;
    try {
      if (mgr && variantId && typeof mgr.getProductIdFromVariantId === 'function') {
        productId = mgr.getProductIdFromVariantId(String(variantId));
      }
    } catch (_) {}
    if (!productId) {
      var pf = form.querySelector('[name="product-id"], [name="product_id"]');
      if (pf && pf.value) productId = pf.value;
    }

    var merged = {};

    // PRICE test props — fail-closed: only with a single known variant + product.
    if (mgr && variantId && productId && typeof mgr.getSimpleCartProperties === 'function') {
      try {
        var price = mgr.getSimpleCartProperties(String(productId), String(variantId));
        if (price && typeof price === 'object') mergeInto(merged, price);
      } catch (_) {}
    }

    // GLOBAL test attribution (theme / URL / shipping / cross-store / checkout /
    // content / page / offer). Not variant-priced; safe to stamp even without a
    // resolved variant (bundles still get order attribution).
    var ctm = getCartTracker();
    if (ctm && typeof ctm.getGlobalTestProperties === 'function') {
      try {
        var global = ctm.getGlobalTestProperties(productId ? String(productId) : undefined);
        if (global && typeof global === 'object') mergeInto(merged, global);
      } catch (_) {}
    }

    Object.keys(merged).forEach(function (key) {
      // Pin to the `_eraya_` prefix so we can never inject another app's props
      // (e.g. the store's own `_productCollections`) onto the cart line.
      if (key.indexOf('_eraya_') !== 0) return;
      var name = 'properties[' + key + ']';
      if (form.querySelector('[name="' + name.replace(/"/g, '\\"') + '"]')) return; // don't double-stamp
      var val = merged[key];
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = typeof val === 'string' ? val : JSON.stringify(val);
      form.appendChild(input);
    });
  }

  function mergeInto(target, src) {
    Object.keys(src).forEach(function (k) { target[k] = src[k]; });
  }

  // Bubble phase (NOT capture) + skip when defaultPrevented: if the theme's
  // product-form custom element already intercepted this submit (AJAX path),
  // defaultPrevented is true and the SDK's fetch/XHR patch handles stamping —
  // we must not also inject or we'd double-stamp. If it's still a real native
  // navigation, we add the inputs now; the browser serializes the form AFTER
  // listeners run, so late-added hidden inputs are included in the POST body.
  document.addEventListener('submit', function (event) {
    if (event.defaultPrevented) return;
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || form.action || '';
    if (action.indexOf('/cart/add') === -1) return;
    try { stampFormWithTestProperties(form); } catch (_) {} // never block add-to-cart
  }, false);

  // 1. PDP / featured / quick-view VARIANT CHANGE
  //    product-info.js morphs #price-{section} with the ORIGINAL price, THEN
  //    publishes FoxTheme pubsub 'variant-change' with { data: { sectionId, variant } }.
  //    The morph is already done when this fires, so re-apply synchronously here
  //    (same tick, before paint) => no flash of the base price. priceMorph
  function onVariantChange(payload) {
    var data = payload && payload.data;
    if (!data) return;
    var variant = data.variant;
    var variantId = variant && String(variant.id);
    if (!variantId) return;

    // Resolve the product id from the section that changed.
    var productId = null;
    if (data.sectionId) {
      var host = document.querySelector('product-info[data-section="' + data.sectionId + '"]');
      if (host) productId = host.getAttribute('data-product-id');
    }
    if (!productId && variant && variant.product_id) {
      productId = String(variant.product_id);
    }
    if (!productId) return;

    syncVariantAttr(productId, variantId);
    reapply(productId, variantId);
  }

  function wirePubsub() {
    try {
      var F = window.FoxTheme;
      if (F && F.pubsub && typeof F.pubsub.subscribe === 'function') {
        var evt = (F.pubsub.PUB_SUB_EVENTS && F.pubsub.PUB_SUB_EVENTS.variantChange) || 'variant-change';
        F.pubsub.subscribe(evt, onVariantChange);
        return true;
      }
    } catch (_) {}
    return false;
  }
  // FoxTheme + theme.js load before this deferred script, but guard/poll anyway.
  if (!wirePubsub()) {
    var tries = 0;
    var pi = setInterval(function () {
      if (wirePubsub() || ++tries > 40) clearInterval(pi);
    }, 250);
  }

  // 2. DYNAMIC CONTENT — AJAX cards get injected (recommendations, predictive
  //    search, quick view, infinite scroll) and price nodes get re-rendered on
  //    card-level variant/swatch swaps. Watch for either and re-apply.
  var obs = null;
  var OBS_OPTS = { childList: true, subtree: true };
  // Run a batch of OUR price writes with the observer paused, so our own
  // rewrites can't re-trigger it into a loop. Samita's later revert re-render
  // is still caught once we reconnect.
  function runPaused(fn) {
    if (obs) obs.disconnect();
    try { fn(); } finally {
      if (obs && document.body) obs.observe(document.body, OBS_OPTS);
    }
  }

  var t = null;
  function scheduleRescan() {
    clearTimeout(t);
    t = setTimeout(function () { runPaused(function () { reapply(); }); }, 150);
  }

  function nodeHasProductCard(n) {
    if (n.nodeType !== 1) return false;
    if (n.hasAttribute && n.hasAttribute('data-product-id')) return true;
    return typeof n.querySelector === 'function' && n.querySelector('[data-product-id]') !== null;
  }

  // A re-rendered price node inside a known product card => re-apply SYNCHRONOUSLY
  // so the shopper never sees the base price flash.
  //
  // This store runs the Samita "All In One Discount" app, which is configured
  // (snippets/samita-custom.liquid) to hijack `.f-price` and render its OWN price
  // markup with `aiod-*` classes. Samita re-renders those nodes from its own
  // data-* attributes, so it will overwrite Eraya's text unless we re-apply after
  // each of its mutations — hence we watch the aiod nodes too and win the last write.
  var PRICE_NODE_SELECTOR =
    '.f-price, .f-price-item--sale, .f-price-item--regular, ' +
    '.aiod-product-crossout-container, .aiod-discounted-price, .aiod-original-price';
  function isPriceNode(n) {
    if (!n.classList) return false;
    return (
      n.classList.contains('f-price') ||
      n.className.indexOf('f-price-item') !== -1 ||
      n.className.indexOf('aiod-') !== -1
    );
  }
  function nodePriceOwner(n) {
    if (n.nodeType !== 1) return null;
    var priceEl = null;
    if (isPriceNode(n)) {
      priceEl = n;
    } else if (typeof n.querySelector === 'function') {
      priceEl = n.querySelector(PRICE_NODE_SELECTOR);
    }
    if (!priceEl || typeof priceEl.closest !== 'function') return null;
    var owner = priceEl.closest('[data-product-id]');
    if (!owner) return null;
    return {
      productId: owner.getAttribute('data-product-id'),
      variantId: owner.getAttribute('data-variant-id'),
    };
  }

  // Resolve the owning card when a price node's TEXT (not element) was replaced —
  // Samita updates prices this way, so addedNodes are bare text nodes.
  function targetPriceOwner(target) {
    if (!target || target.nodeType !== 1 || typeof target.closest !== 'function') return null;
    var priceEl = target.closest(PRICE_NODE_SELECTOR);
    if (!priceEl) return null;
    var owner = priceEl.closest('[data-product-id]');
    if (!owner) return null;
    return {
      productId: owner.getAttribute('data-product-id'),
      variantId: owner.getAttribute('data-variant-id'),
    };
  }

  if (typeof MutationObserver !== 'undefined') {
    obs = new MutationObserver(function (muts) {
      var needRescan = false;
      var seen = {};
      var syncOwners = [];
      function queue(o) {
        if (!o || !o.productId || !o.variantId) return;
        var key = o.productId + ':' + o.variantId;
        if (seen[key]) return;
        seen[key] = true;
        syncOwners.push(o);
      }
      for (var i = 0; i < muts.length; i++) {
        queue(targetPriceOwner(muts[i].target));
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          var o2 = nodePriceOwner(node);
          if (o2) queue(o2);
          else if (nodeHasProductCard(node)) needRescan = true;
        }
      }
      if (syncOwners.length) {
        runPaused(function () {
          for (var k = 0; k < syncOwners.length; k++) {
            reapply(syncOwners[k].productId, syncOwners[k].variantId); // sync, no flash
          }
        });
      }
      if (needRescan) scheduleRescan();
    });
    var start = function () {
      obs.observe(document.body, OBS_OPTS);
    };
    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
  }
})();
